import { PREFECTURES } from "@di-devs/constants";
import { Form, Input, Select } from "antd";
import type React from "react";
import { FLAT_MEMBER_ATTRIBUTE_LABELS } from "../../../../../shared/constants/memberAttribute.constants";
import type { MemberAttribute } from "../../../../../shared/types/member.types";
import { useMemberAttributeContext } from "../../../providers/MemberAttributeContext";
import { FilterWrapper } from "../FilterWrapper";
import type { MemberAttributeFilterConfig } from "../types";

const { Option } = Select;

export const SimpleFilterInput: React.FC<{
	memberAttribute?: MemberAttribute;
	config?: MemberAttributeFilterConfig;
}> = (props) => {
	const memberAttributeContext = useMemberAttributeContext();
	const memberAttribute =
		props.memberAttribute || memberAttributeContext.memberAttribute;
	const config = props.config || memberAttributeContext.config;

	const { memberAttributeId, label, type } = memberAttribute;
	if (!memberAttributeId) return null;

	// Enhanced label for address components
	const displayLabel =
		type.startsWith("address_") && FLAT_MEMBER_ATTRIBUTE_LABELS[type]
			? `${label}（${FLAT_MEMBER_ATTRIBUTE_LABELS[type]}）`
			: label;

	const placeholder =
		config.placeholderPattern === "search"
			? `${displayLabel}を検索`
			: `${displayLabel}を入力してください`;

	const formItem = (
		<Form.Item
			help={config.showHelpText ? displayLabel : undefined}
			name={`memberAttributeFilter${memberAttributeId}`}
			className="mb-4 w-full"
		>
			{type === "address_prefecture" ? (
				<Select placeholder="選択してください" allowClear>
					{PREFECTURES.map((prefecture) => (
						<Option key={prefecture.value} value={prefecture.label}>
							{prefecture.label}
						</Option>
					))}
				</Select>
			) : (
				<Input placeholder={placeholder} allowClear />
			)}
		</Form.Item>
	);

	return (
		<FilterWrapper config={config} itemKey={`${label}${memberAttributeId}`}>
			{formItem}
		</FilterWrapper>
	);
};
